<dnv-navigation
  [user]="userStateService.user()"/>
<div
  class="grid h-full grid-cols-6 justify-items-center gap-6"
  style="grid-template-columns: 1fr 2fr 2fr 2fr 2fr 1fr;"
>
  <div
    class="h-7/8 border-secondary col-start-2 col-end-6 w-full flex flex-col justify-between rounded-xl border-2 bg-white flex-grow overflow-y-auto"
  >
    <dnv-folder />
  </div>
  <div class="flex flex-col items-start gap-4 px-8">
    <div class="flex items-center gap-2">
      <input
        class="custom-file-input"
        type="file"
        ngModel
        #fileUploader
        style="display: none;"
        accept="{{ this.storageStateService.folder()?.allowedFileFormats }}"
        (change)="uploadFile($event)"
      />

      <button class="custom-button rounded-3xl! w-40 h-10" (click)="fileUploader.click()">
        {{ 'FILE_UPLOAD_LIST.ACTIONS.UPLOAD_FILE' | translate }}
      </button>
    </div>

    <button
      class="custom-button rounded-3xl! w-40 h-10"
      [disabled]="!this.storageStateService.files() || this.storageStateService.files().length === 0"
      (click)="downloadAllFiles()"
    >
      {{ 'FILE_UPLOAD_LIST.ACTIONS.DOWNLOAD_ALL' | translate }}
    </button>
  </div>
</div>

@if (storageStateService.folderIdResource.isLoading()) {
  <div
    class="backdrop absolute bottom-0 left-0 right-0 top-0 z-50 flex w-full items-center justify-center"
  >
    <ne-screen-loader />
  </div>
}
